export function fluidDimensions(maxSize, minSize, currentWidth, maxWidth) {
  const value = Math.ceil(maxSize * ((currentWidth ?? maxWidth) / maxWidth))
  if (value < minSize) return minSize
  return value
}

export function moteCardFluidDimensionsAdjuster(
  maxSize,
  minSize,
  currentWidth
) {
  return fluidDimensions((maxSize * 700) / 460, minSize, currentWidth, 700)
}
